const img = require('./bg.mp3'); export default img;